import gql from "graphql-tag";

export const addCategoryMutation = gql`
  mutation addCategory(
    $id: Int
    $name: String
    $description: String
    $logoImage: String
    $bannerImage: String
    $isPopular: Boolean
    $badge: String
    $isJobPhotoRequired: Boolean
    $isDirectBooking: Boolean
    $travellingPrice: Float
    $userServiceFeeValue: Float
    $partnerServiceFeeValue: Float
    $pricingType: String
    $status: String
    $currency: String
    $distanceType: String
  ) {
    addCategory(
      id: $id
      name: $name
      description: $description
      logoImage: $logoImage
      bannerImage: $bannerImage
      isPopular: $isPopular
      badge: $badge
      isJobPhotoRequired: $isJobPhotoRequired
      isDirectBooking: $isDirectBooking
      travellingPrice: $travellingPrice
      userServiceFeeValue: $userServiceFeeValue
      partnerServiceFeeValue: $partnerServiceFeeValue
      pricingType: $pricingType
      status: $status
      currency: $currency
      distanceType: $distanceType
    ) {
      status
      errorMessage
    }
  }
`;

export const deleteCategoryMutation = gql`
  mutation deleteCategory($id: Int) {
    deleteCategory(id: $id) {
      status
      errorMessage
    }
  }
`;

export const updateCategoryStatusMutation = gql`
  mutation updateCategoryStatus(
    $id: Int
    $fieldName: String
    $fieldValue: String
  ) {
    updateCategoryStatus(
      id: $id
      fieldName: $fieldName
      fieldValue: $fieldValue
    ) {
      status
      errorMessage
    }
  }
`;

export const getAllCategory = gql`
  query getAllCategory($currentPage: Int, $searchList: String) {
    getAllCategory(currentPage: $currentPage, searchList: $searchList) {
      count
      results {
        id
        name
        description
        logoImage
        bannerImage
        isPopular
        badge
        isJobPhotoRequired
        travellingPrice
        userServiceFeeValue
        partnerServiceFeeValue
        pricingType
        status
        createdAt
        updatedAt
      }
    }
  }
`;

export const addSubCategoryMutation = gql`
  mutation addSubCategory(
    $id: Int
    $name: String
    $description: String
    $inclusions: String
    $typicalArrival: String
    $image: String
    $categoryId: Int
    $status: String
  ) {
    addSubCategory(
      id: $id
      name: $name
      description: $description
      inclusions: $inclusions
      typicalArrival: $typicalArrival
      image: $image
      categoryId: $categoryId
      status: $status
    ) {
      status
      errorMessage
    }
  }
`;

export const deleteSubCategoryMutation = gql`
  mutation deleteSubCategory($id: Int) {
    deleteSubCategory(id: $id) {
      status
      errorMessage
    }
  }
`;

export const getAllSubCategory = gql`
  query getAllSubCategory($currentPage: Int, $searchList: String) {
    getAllSubCategory(currentPage: $currentPage, searchList: $searchList) {
      count
      results {
        id
        name
        description
        image
        categoryId
        status
        createdAt
        updatedAt
      }
    }
  }
`;

export const updateSubCategoryStatusMutation = gql`
  mutation updateSubCategoryStatus(
    $id: Int
    $fieldName: String
    $fieldValue: String
  ) {
    updateSubCategoryStatus(
      id: $id
      fieldName: $fieldName
      fieldValue: $fieldValue
    ) {
      status
      errorMessage
    }
  }
`;
